<div class="modal-overlay" *ngIf="isVisible" (click)="close()">
    <button class="close-button" (click)="close()">X</button>
    <div class="modal-content" (click)="$event.stopPropagation()">
      <img [src]="imageUrl" alt="No Image" class="modal-image">
    </div>
</div>
  